import API from "./api"; // ✅ Import the existing Axios instance

// ✅ Register a new user
export const registerUser = async (userData) => {
    try {
        const response = await API.post("/users/register", userData);
        return response.data;
    } catch (error) {
        console.error("Error registering user:", error.response?.data || error.message);
        throw error;
    }
};
// ✅ Get all roles from the backend
export const getAllRoles = async () => {
    try {
        const response = await API.get("/roles"); // Assuming '/roles' is the endpoint
        return response.data; // Return fetched roles
    } catch (error) {
        console.error("Error fetching roles:", error.response?.data || error.message);
        throw error; // Re-throw for handling in components
    }
};

// Get all users from the backend
export const getAllUsers = async () => {
    try {
        const response = await API.get("/users");
        return response.data; // Return the data from the response
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error; // Propagate the error for handling elsewhere
    }
};